import { GamesAction, IGamesState, ReduxGamesActionType } from './model';
import { GamesInitState } from './state';

export const gamesReducer = (
  state = GamesInitState,
  action: GamesAction
): IGamesState => {
  switch (action.type) {
    case ReduxGamesActionType.SELECT_MENU_ID:
      return { ...state, selectMenuId: action.result };
    case ReduxGamesActionType.GET_GAMES:
      return { ...state, games: action.result };
    case ReduxGamesActionType.SELECT_GAME:
      // 选择的是gameid
      if (typeof action.result === 'string') {
        const selectGame = state.games.find(
          (item) => item.gameID === action.result
        );
        return { ...state, selectGame: selectGame || null };
      }
      return { ...state, selectGame: action.result };
    case ReduxGamesActionType.ALL_MENU_CONFIG:
      return { ...state, allServiceConfig: action.result };
    case ReduxGamesActionType.OPEN_MENU_STATUS:
      return { ...state, openMenuStatus: action.result };
    case ReduxGamesActionType.SET_ALL_ENVS:
      return { ...state, envs: action.result };
    case ReduxGamesActionType.SELECT_ENV:
      return { ...state, selectEnv: action.result };
    case 'MyFavorite':
      return { ...state, myFavoriteList: action.result };
    case 'ServiceFavoriteTotal':
      return { ...state, serviceFavoriteTotal: action.result };
    case ReduxGamesActionType.ALL_ENV_LIST:
      return { ...state, allEnvList: action.result };
    default:
      return state;
  }
};
